import styled from "@emotion/styled";
import {
    breakpoints,
    colors,
    fontSizes,
    fontWeights,
    gutterSizes,
    mediaQuery,
} from "@gumtree/ui-library/src/base/theme";

export const BannerBackground = styled.div`
    background: ${colors.blue10};
`;

export const BannerContainer = styled.div`
    background: ${colors.blue10};
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: ${gutterSizes.base} !important;
    position: relative;
    max-width: 1350px;
    margin: 0 auto;
    flex-wrap: wrap;

    ${mediaQuery.until(breakpoints.xlarge)} {
        max-width: 1024px;
    }

    ${mediaQuery.until(breakpoints.small)} {
        justify-content: center;
    }

    ${mediaQuery.from(breakpoints.small)} {
        padding-top: ${gutterSizes.large};
        justify-content: center;
    }

    ${mediaQuery.from(breakpoints.medium)} {
        padding-top: ${gutterSizes.xsmall};
    }
`;

export const BannerContent = styled.div`
    margin-bottom: 0;
    display: flex;
    align-items: center;

    h1 {
        margin: 0;
        font-weight: ${fontWeights.normal};
        color: ${colors.blade};
        font-size: ${fontSizes.small};
        text-align: center;
        line-height: 1.2;
        padding: 0 ${gutterSizes.xlarge};
    }

    ${mediaQuery.until(breakpoints.small)} {
        flex-wrap: wrap;
    }
`;

export const BannerClose = styled.button`
    position: absolute;
    top: 3px;
    right: ${gutterSizes.base};
    left: inherit;
    background: none;
    border: none;

    ${mediaQuery.until(breakpoints.large)} {
        right: ${gutterSizes.small};
    }
`;
